import {
  SR_API_ACTION_UPDATE_USER,
} from 'api/actionTypes';

export default async function update({ state, apiClient }, userUpdates) {
  await apiClient.postWithState({
    action: SR_API_ACTION_UPDATE_USER,
    state: state,
    payload: {
      userUpdates,
    },
    onSuccess(userUpdated) {
      state.set(['currentUser'], {
        ...state.get(['currentUser']),
        ...userUpdated,
      });
      state.set(['search', 'filters'], {
        ...userUpdated.searchFilters,
      });
    },
  });
}
